<template>
  <transition name="fade">
    <div v-if="loadingDialog" class="loader-overlay">
      <div class="loader-card">
        <div class="loader-spinner">
          <svg class="loader-svg" viewBox="0 0 50 50">
            <circle class="loader-circle" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>
          </svg>
        </div>
        <span class="loader-text">{{ loadingText || 'Loading...' }}</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["loadingDialog", "loadingText"],
};
</script>

<style scoped>
/* >>> auto-dark: dark companions for the light rules below. Colours here are
   token references only (--app-*, defined in src/plugins/theme-dark.css) — do
   NOT paste literal hexes back in, and do not regenerate this block from the
   light rules: that is what made the palette drift across 226 files before.
   Hand-written `.dark-mode` rules later in this file still override these. <<< */

.dark-mode .loader-card {
  background: var(--app-card);
}

.dark-mode .loader-text {
  color: var(--app-neutral-fg);
}

/* >>> end auto-dark <<< */

.loader-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99998;
}

.loader-card {
  background: #fff;
  border-radius: 16px;
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  font-family: 'Lato', sans-serif;
}

.loader-spinner {
  width: 44px;
  height: 44px;
}

.loader-svg {
  animation: loaderRotate 1.4s linear infinite;
  width: 100%;
  height: 100%;
}

.loader-circle {
  stroke: #0ea5e9;
  stroke-linecap: round;
  animation: loaderDash 1.4s ease-in-out infinite;
}

.loader-text {
  font-size: 0.88rem;
  font-weight: 600;
  color: #475569;
}

@keyframes loaderRotate {
  100% { transform: rotate(360deg); }
}

@keyframes loaderDash {
  0% {
    stroke-dasharray: 1, 126;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 126;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 126;
    stroke-dashoffset: -124;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* Dark mode */
.dark-mode .loader-card {
  background: var(--app-page);
}

.dark-mode .loader-text {
  color: var(--app-neutral-fg);
}

.dark-mode .loader-circle {
  stroke: var(--app-accent);
}
</style>
